








import Vue from 'vue'
//@ts-ignore
import { Chrome } from 'vue-color'
import { Color } from '@/types'

interface ComponentData {
  colorValue: string
  colors: Color | string
}

export default Vue.extend({
  name: 'ColorPicker',

  props: {
    defaultColor: {
      type: String,
      default: '#000'
    }
  },

  components: {
    'chrome-picker': Chrome
  },

  watch: {
    defaultColor (newVal): void {
      if (newVal && newVal !== '') {
        this.colorValue = newVal
        this.colors = newVal
      }
    }
  },

  methods: {
    updateFromPicker (color: Color): void {
      this.colors = color;
      if(color.rgba.a === 1) {
        this.colorValue = color.hex;
      } else {
        this.colorValue = 'rgba(' + color.rgba.r + ', ' + color.rgba.g + ', ' + color.rgba.b + ', ' + color.rgba.a + ')';
      }
      this.$emit('change', color)
    }
  },

  data (): ComponentData {
    return {
      colorValue: '',
      colors: '#000'
    }
  },

  mounted () {
    this.colorValue = this.defaultColor
    this.colors = this.defaultColor
  }
})
